module.exports = __webpack_public_path__ + "img/envelopes-bulk.f0cff7ae.svg";